import React from 'react';
import utils from '../utils/generalFunctions'

const DocumentItem = ({ document, ReadOnly, EnableDelete, deleteDocument }) => {


    return (
        <>
            <tr>
                <td rowSpan={3}>
                {document && document.url && (
                    <a href={document.url}  target='blank'>
                    <div className='file-extension m-0 p-0'>
                            {utils.getExtensionIcon('.'+document?.name.split('.').pop().toLowerCase())}
                        </div>
                    </a>
                )}
                {document && !document.url && (
                <div className='file-extension m-0 p-0'>
                    {utils.getExtensionIcon('.'+document?.name.split('.').pop().toLowerCase())}
                </div>
                )}
                </td>
                <td></td>
                <td></td>
                <td rowSpan={3}>
                {!ReadOnly && (
                    <>
                        {!EnableDelete  && (
                            <a className='btn btn-sm btn-danger btn-round text-start' onClick={(e) => {e.preventDefault(); deleteDocument(document); }}> 
                                <i className="icon-deactivate fas fa-times" aria-hidden="true"></i>
                            </a>
                        )}
                    </>
                    )}
                </td>
            </tr>
            <tr>
                {document && document.url && (
                    <td colSpan={2}>
                        <a href={document.url} target='blank'><small className="text-muted text-nowrap">{document?.name}</small></a></td>
                )}
                    {document && !document.url && (
                    <td colSpan={2}><small className="text-muted text-nowrap">{document?.name}</small></td>
                )}
            </tr>
            <tr>
                 {document && document.url && (
                    <td colSpan={2}>
                        <a href={document.url} target='blank'><small className="text-muted">{utils.formatBytes(document?.size??0)}</small></a>
                    </td>
                )}
                    {document && !document.url && (
                    <td colSpan={2}><small className="text-muted">{utils.formatBytes(document?.size??0)}</small></td>
                )}
                
            </tr>                                   
        </>
    );
};

export default DocumentItem;
